import { Grid, StyledEngineProvider, Card } from '@mui/material';
import AuthLogin from '../../components/signin/AuthLogin';
import { useNavigate } from 'react-router-dom';
import React, { useEffect } from 'react';
import Storage from '../../services/Storage';

const Signin = () => {
    const navigate = useNavigate();

    useEffect(() => {
        if (Storage.getLocalAccessToken() !== null) {
            navigate('/dashboard', { replace: true })
        }
    }, [navigate]);
    
    return (
        <StyledEngineProvider injectFirst>
            <Card>
                <Grid container spacing={2} alignItems="center" justifyContent="center">
                    <Grid item xs={12}>
                        <AuthLogin />
                    </Grid>
                </Grid>
            </Card>
        </StyledEngineProvider>
    );
};

export default Signin;
